
(function () {
  function initSeasonalReviews(root) {
    if (!root || root.dataset.srInitialized === 'true') return;

    root.dataset.srInitialized = 'true';

    const tabs = root.querySelectorAll('[data-tab]');
    const panels = root.querySelectorAll('[data-panel]');

    if (!tabs.length || !panels.length) return;

    function setupSwiper(panel) {
      const track = panel.querySelector('.seasonal-reviews__track');
      const pagination = panel.querySelector('.seasonal-reviews__pagination');

      if (!track || !pagination || typeof Swiper === 'undefined') return;

      // Already initialized: just recalculate (panel was hidden before)
      if (track.swiper) {
        track.swiper.update();
        track.swiper.slideTo(0, 0);
        return;
      }

      new Swiper(track, {
        slidesPerView: 1.5,
        spaceBetween: 10,
        speed: 400,
        grabCursor: true,
        watchOverflow: true,
        pagination: {
          el: pagination,
          clickable: true,
          bulletClass: 'seasonal-reviews__dot',
          bulletActiveClass: 'is-active',
          renderBullet: function (index, className) {
            return (
              '<button type="button" class="' + className +
              '" aria-label="Go to review ' + (index + 1) + '"></button>'
            );
          }
        },
        breakpoints: {
          750: {
            slidesPerView: 2,
            spaceBetween: 10
          },
          1199: {
            slidesPerView: 3,
            spaceBetween: 10
          }
        }
      });
    }

    function destroySwipers() {
      root.querySelectorAll('.seasonal-reviews__track').forEach(function (track) {
        if (track.swiper) track.swiper.destroy(true, true);
      });
    }

    function activateTab(selectedTab) {
      const selectedCategory = selectedTab.dataset.tab;

      tabs.forEach(function (tab) {
        const isActive = tab === selectedTab;

        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', String(isActive));
        tab.tabIndex = isActive ? 0 : -1;
      });

      panels.forEach(function (panel) {
        const isActive = panel.dataset.panel === selectedCategory;

        panel.hidden = !isActive;

        if (isActive) {
          // wait one frame so the panel has real width before Swiper measures it
          window.requestAnimationFrame(function () {
            setupSwiper(panel);
          });
        }
      });
    }

    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () {
        activateTab(tab);
      });

      tab.addEventListener('keydown', function (event) {
        let nextIndex = index;

        if (event.key === 'ArrowRight') {
          nextIndex = (index + 1) % tabs.length;
        } else if (event.key === 'ArrowLeft') {
          nextIndex = (index - 1 + tabs.length) % tabs.length;
        } else {
          return;
        }

        event.preventDefault();
        tabs[nextIndex].focus();
        activateTab(tabs[nextIndex]);
      });
    });

    const defaultTab =
      root.querySelector('[data-tab].is-active') || tabs[0];

    activateTab(defaultTab);

    // Shopify theme editor cleanup
    root.addEventListener('sr:destroy', destroySwipers);
  }

  function initAllSeasonalReviews() {
    document.querySelectorAll('[data-seasonal-reviews]')
      .forEach(initSeasonalReviews);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllSeasonalReviews);
  } else {
    initAllSeasonalReviews();
  }

  document.addEventListener('shopify:section:load', function (event) {
    const section = event.target.querySelector('[data-seasonal-reviews]');

    if (section) {
      initSeasonalReviews(section);
    }
  });

  document.addEventListener('shopify:section:unload', function (event) {
    const section = event.target.querySelector('[data-seasonal-reviews]');

    if (section) {
      section.dispatchEvent(new Event('sr:destroy'));
    }
  });

})();